import StudentSubjectsData from './StudentSubjectsData';

export default StudentSubjectsData;
